export function getElementType(Component, hasDefault) {
  if (Component.as && Component.as !== hasDefault) return Component.as

  if (Component.href) return 'a'

  if (Component.buttonType) return 'button'

  if (hasDefault) return hasDefault

  return 'div'
}
